@if (configMap.inciteESIIndicators?.active || _showTagsArea) {
  <mat-card class="info-block">
    @if (configMap.inciteESIIndicators?.active) {
      @if (data()?.highlyCitedPaper) {
        <div class="flag-term highly-cited">
          <mat-icon svgIcon="incites-highly-cited"></mat-icon>
          {{ 'research.portal.fulldisplay.incitesHighlights.highlyCitedPaper' | translate }}&nbsp;
        </div>
      }
      @if (data()?.hotPaper) {
        <div class="flag-term hot-paper">
          <mat-icon svgIcon="incites-hot-paper"></mat-icon>
          {{ 'research.portal.fulldisplay.incitesHighlights.hotPaper' | translate }}&nbsp;
        </div>
      }
    }
    @if (_showTagsArea && _hasTagsData) {
      <mat-icon class="tags-icon" svgIcon="tag-multiple"></mat-icon>
      <dl>
        @if (_hasCollabs && configMap.inciteCollaboration?.active) {
          <div class="highlight-grouping">
            <dt translate="esploro.research.conf.research.portal.label.prefix.inciteCollaboration"></dt>
            @if (data()?.industryCollaboration) {
              <dd
                translate="research.portal.fulldisplay.incitesHighlights.industryCollaboration"
              ></dd>
            }
            @if (data()?.institutionCollaboration) {
              <dd
                translate="research.portal.fulldisplay.incitesHighlights.institutionCollaboration"
              ></dd>
            }
            @if (data()?.internationalCollaboration) {
              <dd
                translate="research.portal.fulldisplay.incitesHighlights.internationalCollaboration"
              ></dd>
            }
          </div>
        }
        @if (configMap.inciteCitationTopics?.active) {
          @if (data()?.metricsValueMap?.['ct']; as ct) {
            @if (ct?.length > 0) {
              <div class="highlight-grouping">
                <dt translate="esploro.research.conf.research.portal.label.prefix.inciteCitationTopics"></dt>
                @for (topic of ct; track topic) {
                  <dd>{{ topic.subject }}</dd>
                }
              </div>
            }
          }
        }
        @if (configMap.inciteWOSResearchAreas?.active) {
          @if (data()?.metricsValueMap?.['wos']; as wos) {
            @if (wos?.length > 0) {
              <div class="highlight-grouping">
                <dt translate="esploro.research.conf.research.portal.label.prefix.inciteWOSResearchAreas"></dt>
                @for (area of wos; track area) {
                  <dd>{{ area.subject | titlecase }}</dd>
                }
              </div>
            }
          }
        }
        @if (configMap.inciteESIResearchAreas?.active) {
          @if (data()?.metricsValueMap?.['esi']; as esi) {
            @if (esi?.length > 0) {
              <div class="highlight-grouping">
                <dt translate="esploro.research.conf.research.portal.label.prefix.inciteESIResearchAreas"></dt>
                @for (area of esi; track area) {
                  <dd>{{ area.subject }}</dd>
                }
              </div>
            }
          }
        }
      </dl>
    }
  </mat-card>
}
